// Tabs a company can grant, shown in the buyer and manager sidebars.
//
// Shared between the Site Management form (which writes site.sidebarTabs) and
// the sidebars that read it, so the two can't drift apart. `key` is what gets
// persisted — renaming one orphans existing site records, so add new entries
// rather than renaming old ones.
//
// Not used by the other two roles, deliberately: admins always see everything
// so they can configure it, and the plain 'user' role always sees Action Plan
// only, hard-coded in UserSidebar.
export const SITE_SIDEBAR_TABS = [
  { key: 'dashboard', label: 'Dashboard', path: '/admin/dashboard' },
  { key: 'sitemanagement', label: 'Site Management', path: '/admin/sitemanagement' },
  { key: 'users', label: 'User Management', path: '/user/users' },
  { key: 'stock', label: 'Sales Management', path: '/admin/stock' },
  {
    key: 'specialmanagement',
    label: 'Action Plan',
    path: '/admin/specialmanagement'
  },
  {
    key: 'tailoringmanagement',
    label: 'Off and Leave Management',
    path: '/admin/tailoringmanagement'
  },
  {
    key: 'experiencemanagement',
    label: 'Guest Experience',
    path: '/admin/experiencemanagement'
  },
  { key: 'checklists', label: 'Checklists', path: '/admin/checklists' }
];

// What a company sees when sidebarTabs was never configured: everything that is
// visible today, so existing companies keep the menu they already have until
// someone opts them in.
export const DEFAULT_SITE_SIDEBAR_TABS = SITE_SIDEBAR_TABS.map(t => t.key);

// Resolve the tabs a buyer or manager may see: the union across every company
// they belong to. Falls back to the full set when nothing usable is configured
// — an empty sidebar would leave them with no way to navigate.
export const resolveSiteSidebarTabs = (user, sites) => {
  const access = (user?.access || []).map(String);
  if (!access.length || !Array.isArray(sites) || !sites.length) {
    return DEFAULT_SITE_SIDEBAR_TABS;
  }

  const granted = new Set();
  sites
    .filter(site => access.includes(String(site._id)))
    .forEach(site => {
      (site.sidebarTabs || []).forEach(tab => granted.add(tab));
    });

  return granted.size ? Array.from(granted) : DEFAULT_SITE_SIDEBAR_TABS;
};
